// extracted by mini-css-extract-plugin
export default {"container":"DurationAndPrescribedPractical__container___wEPsj","termsDropdown":"DurationAndPrescribedPractical__termsDropdown___gICoX"};